import React from "react";
import { useState, useEffect } from "react";

import { Button } from "react-bootstrap";
import _ from 'lodash';
import cx from "classnames";

import { Property } from "components/Editor/components/properties";

import styles from "./brandkit.components.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateWorkspace } from "actions/workspace";
import { updateBrandkitEnableToggle } from "actions/brandKit/brandKit";
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_BRANDKIT_SHOW_ONLY_TOGGLED } from "constants/mixpanelEvents";

export default function Header({
  paletteId,
  selectedCategory,
  toggleBrandElements,
  setToggleBrandElements,
  deleteHandler,
  loading,
  selectedItems,
  children
}) {

  const dispatch = useDispatch();
  const [customFontsEnabled, setCustomFontsEnabled] = useState(false);
  const workspaceId = useSelector(state => _.get(state, 'workspaces.workspace.item.id', ''));
  const customFonts = useSelector(state => _.get(state, 'workspaces.workspace.item.customFonts', ''));
  const toggleHide = ['images', 'videos', 'Colours'].includes(selectedCategory)

  const customStyles = {
    pointerEvents: "none",
    opacity: 0.5,
    cursor: "default",
  };

  useEffect(() => {
    setCustomFontsEnabled(customFonts)
  },[customFonts])

  const handleToggle = (type) => {
    if (type !== 'Fonts'){
      const request = {
        "enabled" : !toggleBrandElements
      }
      setToggleBrandElements(!toggleBrandElements)
      dispatch(updateBrandkitEnableToggle(paletteId, request))
    }
    if (type === 'Fonts'){
      const request = {
        "customFontsEnabled" : !customFontsEnabled
      }
      setCustomFontsEnabled(!customFontsEnabled);
      dispatch(updateWorkspace(workspaceId, request));
    }

    const mixpanelPayload = {
      brandkit_element_type: type,
      toggle_type: type === 'Fonts' ? !customFontsEnabled : !toggleBrandElements
    }

    dispatch(createMixpanelEvent(MIXPANEL_BRANDKIT_SHOW_ONLY_TOGGLED, mixpanelPayload))
  }

  const capitalizeWords = (str) => {
    return str.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

  return (
    <div className={cx(styles.headerWrapper)} style={loading ? customStyles : undefined}>
      <span className={styles.selectedCategory}>{selectedCategory.replace(/_/g, ' ')}</span>
      <ul>
        {/* <li>
          <Button variant="secondary" className={styles.btnIcons}>
            <i className={"cleverstory-search"} />
          </Button>
        </li>
        <li>
          <Button variant="secondary" className={styles.btnIcons}>
            <i className={"cleverstory-sort"} />
          </Button>
        </li>
        <li>
          <Button variant="secondary" className={styles.btnIcons}>
            <i className={"cleverstory-move-folder"} />
          </Button>
        </li> */}
        <li>
          <Button
            variant="secondary"
            className={styles.btnIcons}
            onClick={deleteHandler}
            disabled={selectedItems?.length === 0}
          >
            <i className={"cleverstory-trash"} />
          </Button>
        </li>
        {!toggleHide && <li className={styles.spanLiner}></li>}
        {!toggleHide && <li
          className={styles.toggleWrapper}
          onClick={() => handleToggle(capitalizeWords(selectedCategory))}
        >
          <label className={styles.brandElemenLabel}>
            Show Only Brand {capitalizeWords(selectedCategory)}
          </label>
          <Property.Switch
            id="brand-elements"
            title={""}
            value={selectedCategory === 'fonts' ? customFontsEnabled : toggleBrandElements}
          />
        </li>}
        <li className={styles.spanLiner}></li>
        {/* <li>
          <Button variant="secondary" className={styles.btnIcons}>
            <i className={"cleverstory-add-folder"} style={{ fontSize: "14px" }} />
          </Button>
        </li> */}
        <li>{children}</li>
      </ul>
    </div>
  );
}